import React from 'react';
import styled from '@emotion/styled';
import { Colors } from 'utils';
import PropTypes from 'prop-types';

const ProgressBarWrapper = styled.div`
  width: 100%;
  background: #e9eaeb;
  border-radius: 8px;
  div {
    width: ${(props) =>
      props.percentage
        ? `${props.percentage > 100 ? '100' : props.percentage}%`
        : '0'};
    background: #c3d3a5;
    height: 8px;
    border-radius: 8px;
  }
`;
export default function ProgressBar(props) {
  return (
    <ProgressBarWrapper
      percentage={props.percentage}
      className={
        props.percentage >= 100 ? 'progress-bar complete' : 'progress-bar'
      }
    >
      <div></div>
    </ProgressBarWrapper>
  );
}

ProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
};
